import React from 'react';
import { Box } from '@mui/material';
import { LayoutItem } from 'react-grid-layout';
import { ReactComponent as DeviceErrorIcon } from '../../../../../../../../assets/dashboard/DeviceError.svg';
import {
  ILabelValuePanel,
  IFlexeserveDeviceErrorPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import useAirConnectStatus from '../../../../../../../../service/device/CommanderAPI/hooks/useAirConnectStatus';

export interface FlexeserveDeviceErrorPanelProps {
  panel: IFlexeserveDeviceErrorPanel;
  layout?: LayoutItem | undefined;
}

function FlexeserveDeviceErrorPanel(props: FlexeserveDeviceErrorPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const { isFetching, currentData, error } = useAirConnectStatus(panel);

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `flexeserve_device_error`,
    title: panel.title,
    icon: <DeviceErrorIcon height={'100%'} />,
    content: (
      <Box
        width="100%"
        height={'100%'}
        minWidth={120}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        {currentData?.nodeLost ?? 0}
      </Box>
    ),
    loading: isFetching,
    error: error ? t('dashboard.error.fetching') : undefined,
  };
  return <LabelValuePanel panel={labelValuePanel} layout={layout} />;
}

export default FlexeserveDeviceErrorPanel;
